var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacePledgeLogoBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 58",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "PlacePledge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 38,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 1000,
    letterSpacing: 10,
    textAnchor: "end"
  }, "PLACE"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 0)",
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.5 39l9.8-5.6 9.8 5.6 9.4-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.3 33.4V16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.1 39V21.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5 11.5c-4.9 0-8.8 3.9-8.8 8.6 0 6.9 8.8 13.8 8.8 13.8s8.8-6.9 8.8-13.8c0-4.7-3.9-8.6-8.8-8.6Z",
    fill: "#111827"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 205.5,
    cy: 20.1,
    r: 2.8,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 38,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 1000,
    letterSpacing: 10
  }, "PLEDGE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacePledgeLogoBold);
export default __webpack_public_path__ + "static/media/place-pledge-logo-bold.fb1f5d5e2ac4b7f2062f5adaa6fe297f.svg";
export { ForwardRef as ReactComponent };